import {JSEncrypt} from 'jsencrypt'
//加密解密
const _encrypt = new JSEncrypt();
const _decrypt = new JSEncrypt();
const key="MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCULGlp4gg90eW7ulPqM+c4XOpXPz2q8LJzCfBKE+y11Xu4IRHJYvZDuZWEuyiixNFgyWTQnFDv2DRpGqpOiUkNXFq89URyDE3+xhJuh1IhYbgJbTcFqmHo9Tj15bBECAttDNuW9Ww4ZfcFz1vLYofxXHppsErFvhuPyZb0tvMZ1QIDAQAB";
const key1="MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAJQsaWniCD3R5bu6U+oz5zhc6lc/ParwsnMJ8EoT7LXVe7ghEcli9kO5lYS7KKLE0WDJZNCcUO/YNGkaqk6JSQ1cWrz1RHIMTf7GEm6HUiFhuAltNwWqYej1OPXlsEQIC20M25b1bDhl9wXPW8tih/FcemmwSsW+G4/JlvS28xnVAgMBAAECgYAiFL0CT60Zmwe+UDMw8VNDkYuNGcyzXr2M3EJap46QnFPinCidK5f9J9iOOQY1uhN2sZvwp6OuJwqXCj0V51nX0MCdBwIE1LgV94/9FGz6aXKO9DXC8IvoYwvrCaePdnxyoO17Msyaf/XR7AhCrzmzZCd5goJwi0/QpvQAcyfqQQJBANkZwzXzPRgn7j73m00x/pfuTtT0IFqXfDLC9+AOp/RVMK7U46gpDExJtjVkmNkWfSF/PPrWJBtEUlnkS9LRGzkCQQCuuQOr+RGDzu5DI9leKYe6LmWIDChJdW04C5N6iAO0rVoQYOlNeDRpjx4MQeA/Hpnd7ygORuVEI1uebHZurEd9AkB7SV8LJyudqSdpyLD/4JFE9Eb+NfidmYMlTIT5TzlfznUMA8eYul7Kf92iapNGTLgYqqoVhEAS3/SoKbZJbQg5AkEAlQva5/8GQ+xoL/oK2VqQH/CoSBAm5dM4IlEts58Hmj8uzz38h0t9Wnbt6QLhKrcOBtaW0ucDeMa4x0I7HVn1eQJBAJBaBnGGP66EM+u2D4kinui/eXJV5fLGLjJVZ3fJ1xXW6+HfPGbz6yehKtyGNz6qAy3mFf1eJUx/pXoHptKjcto=";
//配置公钥
_encrypt.setPublicKey(key); // 加密
_decrypt.setPrivateKey(key1); // 解密
// 加密
function encrypt(text){
  if (!text){
    return ''
  }
  if(typeof text === 'object'){
    text = JSON.stringify(text)
  }
  return _encrypt.encrypt(text)
}

// 解密
function decrypt(text){
  if (!text){
    return ''
  }
  return _decrypt.decrypt(text)
}

export { encrypt, decrypt }



// WEBPACK FOOTER //
// ./src/modules/utils/jsencrypt.js